import { useTranslation } from "react-i18next";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ContactSuccessState = ({ success, onReset }) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid="inquiry-success-state"
      className="rounded-xl border border-emerald-200 bg-emerald-50 p-6"
    >
      <div className="flex items-center gap-2 text-emerald-700">
        <CheckCircle2 className="h-5 w-5" />
        <span className="text-sm font-semibold">{t("contact.successKicker")}</span>
      </div>
      <h3 className="mt-3 text-xl font-extrabold text-slate-900">{t("contact.successTitle")}</h3>
      <p className="mt-2 text-sm text-slate-600">
        {t("contact.referenceLabel")}{" "}
        <span
          className="font-mono font-semibold text-slate-900"
          data-testid="inquiry-reference"
        >
          {success.reference}
        </span>
      </p>
      <p className="mt-3 text-sm text-slate-600">{t("contact.successBody")}</p>
      <Button
        type="button"
        onClick={onReset}
        data-testid="inquiry-submit-another-button"
        variant="outline"
        className="mt-5 h-11 rounded-lg border-slate-300 bg-white px-5 text-slate-900 hover:bg-slate-50"
      >
        {t("cta.submitAnother")}
      </Button>
    </div>
  );
};
